import './assets/checkout.css';
import { createApp, AppRoute } from '@domgen/whirlpool-olr';
import { ClientLogo } from './assets/icons/ClientLogo';
import { toBool } from '@domgen/shared/utils/vite-env/toBool';
import { TwoYearPartsPage } from './pages/TwoYearParts';

const {
  VITE_OTEL_EXPORTER_OTLP_ENDPOINT,
  VITE_OTEL_LIGHTSTEP_TOKEN,
  VITE_OTEL_SERVICE_VERSION,
  VITE_OTEL_SERVICE_NAME,
  VITE_BASE_API_URL,
  VITE_PR_ID,
  VITE_APP_PATH,
  MODE,
  VITE_BRAND_CODE,
  VITE_CLIENT_FRIENDLY_NAME,
  VITE_RECAPTCHA_SITE_KEY,
  VITE_ADOBE_TAGS_ENABLED,
  VITE_ADOBE_TAG_MANAGER_SCRIPT_URL,
  VITE_COOKIE_PRO_BRAND_SCRIPT_ID,
  VITE_COOKIE_PRO_SRC,
  VITE_POSTHOG_API_KEY,
  VITE_POSTHOG_HOST,
  VITE_CHECKOUT_SDK_URL,
} = import.meta.env;

createApp({
  clientLogo: <ClientLogo />,
  environment: MODE as 'sandbox' | 'development' | 'qa' | 'production',
  brandCode: VITE_BRAND_CODE,
  brandFriendlyName: VITE_CLIENT_FRIENDLY_NAME,
  serviceName: VITE_OTEL_SERVICE_NAME,
  recaptchaSiteKey: VITE_RECAPTCHA_SITE_KEY,
  version: VITE_OTEL_SERVICE_VERSION,
  appPath:
    `${VITE_PR_ID ? `/${VITE_PR_ID}` : ''}${VITE_APP_PATH ? `/${VITE_APP_PATH}` : VITE_PR_ID ? '' : '/'}`.trim(),
  cookiePro: {
    brandScriptId: VITE_COOKIE_PRO_BRAND_SCRIPT_ID,
    src: VITE_COOKIE_PRO_SRC,
  },
  adobeTags: {
    enabled: toBool(VITE_ADOBE_TAGS_ENABLED),
    scriptUrl: VITE_ADOBE_TAG_MANAGER_SCRIPT_URL,
  },
  checkoutCDN: VITE_CHECKOUT_SDK_URL,
  otel: {
    otelExporterEndpoint: VITE_OTEL_EXPORTER_OTLP_ENDPOINT,
    otelToken: VITE_OTEL_LIGHTSTEP_TOKEN,
    ignoreUrls: [
      /google-analytics.com/, // ignore Google Analytics requests
      /.*\.lightstep\.com/, // ignore LightStep export requests
    ],
    traceParentCorsUrls: [new RegExp(VITE_BASE_API_URL)],
  },
  posthogConfig: {
    host: VITE_POSTHOG_HOST,
    key: VITE_POSTHOG_API_KEY,
  },
  apiBaseUrl: VITE_BASE_API_URL,
  isMaintenanceModeEnabled: toBool(import.meta.env.VITE_MAINTENANCE_MODE_ENABLED),
  routes: [
    {
      path: AppRoute.TWO_YEAR_PARTS,
      title: '2 Year Parts - Terms and Conditions',
      element: <TwoYearPartsPage />,
    },
  ],
});
